import React, { useContext } from "react";
import FileUploadComponent from "../fileUpload/FileUploadComponent.js";
import OverviewRightPanelClient from "../panels/OverviewRightPanelClient";
import "../../styling/ClientPortal.css";
import { EventDataContext } from "../EventDataContext";

import businessPhoto from "../../images/BoothBloom_Banner_Business.jpg";
import weddingPhoto from "../../images/BoothBloom_Banner_Wedding.jpg";
import birthdayPhoto from "../../images/BoothBloom_Banner_Birthday.jpg";
import otherPhoto from "../../images/BoothBloom_Banner_Other.jpg";

const OverviewTab = ({ brandingColours, clientData, businessId }) => {
  const { EventData } = useContext(EventDataContext);

  // Determine cover picture based on event type
  let coverPic = otherPhoto;
  if (EventData.eventType === "corporate") {
    coverPic = businessPhoto;
  } else if (EventData.eventType === "birthday") {
    coverPic = birthdayPhoto;
  } else if (EventData.eventType === "wedding") {
    coverPic = weddingPhoto;
  }

  // Date Formatting
  const eventDate = EventData.eventDate ? new Date(EventData.eventDate) : new Date();
  const startTime = EventData.startTime ? new Date(EventData.startTime) : null;
  const endTime = EventData.endTime ? new Date(EventData.endTime) : null;

  const optionsTime = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };

  return (
    <div className="overviewClientContainer" style={{ display: 'flex', width: '100%' }}>
      <div className="overviewClientLeftPanel" style={{ flex: 1, position: 'relative' }}>
        
        {/* Banner Section */}
       {/* Banner Section with Blur and Gradient */}
       <div style={{ position: 'relative', width: '100%', height: '224px', overflow: 'hidden', backgroundColor: '#000' }}>
          {/* 1. The Base Image */}
          <img
            src={coverPic}
            alt="Event Banner"
            style={{ 
              width: "100%", 
              height: "100%", 
              objectFit: "cover",
              objectPosition: "top" 
            }}
            className="overviewClientLeftPanelImage"
            onError={(e) => { e.target.src = otherPhoto; }}
          />

          {/* 2. The Blur Overlay */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            maskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
            WebkitMaskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
          }} />
          
          {/* 3. The Bottom Gradient & Text Overlay */}
          <div style={{
            position: 'absolute',
            bottom: '0',
            left: '0',
            width: '100%',
            background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
            color: 'white',
            padding: '20px',
            boxSizing: 'border-box'
          }}>
            <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>
              {EventData.eventName || "Untitled Event"}
            </h1>
            <p style={{ margin: '5px 0 0 0', fontSize: '14px', opacity: 0.9 }}>
              Date Booked: {eventDate.toLocaleDateString()}
            </p>
          </div>
        </div>

        {/* Content Section */}
        <div className="event-overview-content-container" style={{ padding: '10px' }}>
          <div style={{ padding: "20px", fontWeight: "300" }} className="event-overview-div">
            <h2 style={{ color: "#000000", marginBottom: '15px' }}>Event Overview</h2>
            <p style={{ width: "100%", color: "#4D4D4D", lineHeight: '1.5' }}>
              {EventData?.details || "No details provided for this event."}
            </p>
          </div>

          <div style={{ padding: "20px", fontWeight: "300", color: "#000000" }} className="event-overview-div">
            <h2 style={{ fontWeight: "400" }}>Event Details</h2>
            
            <div style={{ marginBottom: '15px' }}>
              <h4 style={{ fontWeight: "500", marginBottom: "2px" }}>Date</h4>
              <p style={{ color: "#625C73", margin: 0 }}>{eventDate.toLocaleDateString()}</p>
            </div>

            <div style={{ marginBottom: '15px' }}>
              <h4 style={{ fontWeight: "500", marginBottom: "2px" }}>Time</h4>
              <p style={{ color: "#625C73", margin: 0 }}>
                {startTime && endTime 
                  ? `${startTime.toLocaleTimeString('en-US', optionsTime)} - ${endTime.toLocaleTimeString('en-US', optionsTime)}`
                  : "Time not set"}
              </p>
            </div>

            <div style={{ marginBottom: '15px' }}>
              <h4 style={{ fontWeight: "500", marginBottom: "2px" }}>Location</h4>
              <p style={{ color: "#625C73", margin: 0 }}>
                {EventData?.address || "Location pending"}
              </p>
            </div>
          </div>

          <div style={{ padding: "20px" }} className="event-overview-div">
            <h2 style={{ fontWeight: "400", color: "#000000", marginBottom: "15px" }}>
              Documents &amp; Files
            </h2>
            <FileUploadComponent brandingColours={brandingColours} eventId={EventData._id} user="client" />
          </div>
        </div>
      </div>

      {/* Right Panel */}
      <div className="overviewClientRightPanel" style={{ width: '300px' }}>
        <OverviewRightPanelClient brandingColours={brandingColours} businessId={businessId} />
      </div>
    </div>
  );
};

export default OverviewTab;